<main class="login-page">
  <section class="login-card" aria-labelledby="login-title">
    <span class="brand-mark" aria-hidden="true">S</span>
    <p class="eyebrow">SERG</p>
    <h1 id="login-title">Your private workspace</h1>
    <p>Sign in to keep your conversations private and available across devices.</p>

    @if (auth.isConfigured) {
      <button type="button" class="google-button" (click)="signIn()">
        <span aria-hidden="true">G</span>
        Continue with Google
      </button>
    } @else {
      <p class="auth-error">Supabase configuration is missing. Add the project URL and publishable key to <code>environment.local.ts</code>.</p>
    }

    @if (auth.error(); as error) {
      <p class="auth-error" role="alert">{{ error }}</p>
    }
  </section>
</main>
